import store from "@/store";

// 是否是工商或普通租户
export function isVendor(vendor) {
  const tenantInfo = store.state.tenant.tenantInfo;
  if (tenantInfo && tenantInfo.vendor) {
    // 1 普通租户、2 是工商局租户
    return tenantInfo.vendor == vendor;
  }
  return false;
}

// 是否是子租户
export function isSubTenant() {
  const tenantInfo = store.state.tenant.tenantInfo;
  if (tenantInfo && tenantInfo.isSubTenant) {
    return tenantInfo.isSubTenant == 1;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/lib/tenant.js